import React from "react";
import { Icons } from "../../components/common/Icons";
import { useInternData } from "../../context/InternContext";

function WelcomeBanner() {
  const { internData } = useInternData();

  return (<div className="welcome-banner animate-in delay-1"><div className="welcome-top"><div><div className="welcome-greeting">Welcome back, {internData.name || 'Intern'} 👋</div><div className="welcome-sub">{internData.role} · {internData.team}</div><div className="welcome-badge-row"><span className="welcome-badge verified"><Icons.Shield /> Verified & Approved</span><span className="welcome-badge">📅 {internData.startDate} → {internData.endDate}</span><span className="welcome-badge">👤 Manager: {internData.manager}</span></div></div><div className="id-badge">{internData.id}</div></div></div>);}


export default WelcomeBanner;
